// extracted by mini-css-extract-plugin
export default {"sidenav":"style_sidenav__1FrWj","nav_link":"style_nav_link__WxmdD","active":"style_active__8bqPY"};